import { useState } from 'react';

export interface OnboardingData {
  familyName: string;
  spouseName: string;
  children: string[];
  familyPhoto?: string;
  spousePhoto?: string;
  childrenPhotos: { [index: number]: string };
}

export const useOnboardingState = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [data, setData] = useState<OnboardingData>({
    familyName: '',
    spouseName: '',
    children: [],
    familyPhoto: undefined,
    spousePhoto: undefined,
    childrenPhotos: {}
  });

  const updateData = (updates: Partial<OnboardingData>) => {
    setData(prev => ({ ...prev, ...updates }));
  };

  const nextStep = () => {
    if (currentStep < 3) {
      setCurrentStep(prev => prev + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 1) {
      setCurrentStep(prev => prev - 1);
    }
  };

  const goToStep = (step: number) => {
    if (step >= 1 && step <= 3) {
      setCurrentStep(step);
    }
  };

  const canProceed = () => {
    switch (currentStep) {
      case 1:
        return data.familyName.trim().length > 0;
      case 2:
        return true; // Always allow proceeding from step 2 (spouse is optional)
      case 3:
        return true; // Children are optional
      default:
        return false;
    }
  };

  return {
    currentStep,
    data,
    updateData,
    nextStep,
    prevStep,
    goToStep,
    canProceed
  };
};